import { IFormData } from "./IFormData";
import { app } from "./App";
import { EventDispatcher } from "../Events/EventDispatcher";
import { PopupEventArgs } from "./PopupEventArgs";
import { FixedDialog, DialogResult } from "../Controls/FixedDialog";
import { LockManager } from "../Common/LockManager";
import { IPopupResult, PopupResults } from "../Controls/IPopupResult";

export class Popup {
    public form: HTMLFormElement;
    protected modalContainer: HTMLElement;
    protected iFrame: HTMLIFrameElement;

    constructor(public data: IFormData) {
    }

    public create(params: string) {
        console.log("popup.create");

        this.modalContainer = document.createElement("div");
        this.modalContainer.className = "modal-container";

        document.getElementsByTagName("body")[0].appendChild(this.modalContainer);

        let contentContainer = document.createElement("div");
        contentContainer.className = "modal-content";
        this.modalContainer.appendChild(contentContainer);


        let waitIcon = document.createElement("div");
        waitIcon.className = "spinner-border";
        waitIcon.style.marginLeft = "50%";
        waitIcon.style.marginTop = "50vh";

        //let waitIcon = document.createElement("i");
        //waitIcon.className = "fa fa-spinner fa-pulse fa-4x fa-fw";
        //waitIcon.style.position = "absolute";
        //waitIcon.style.transform = "translate(-50%, -50%)";
        //waitIcon.style.left = "50%";
        //waitIcon.style.top = "50%";
        //            waitIcon.style.color = "#0078d0";
        this.modalContainer.appendChild(waitIcon);

        this.iFrame = document.createElement("iframe");
        let url = app.resolveUrl(this.data.url);
        if (url.indexOf("?") > 0) {
            url += "&"
        }
        else {
            url += "?";
        }
        if (params && params.length > 0) {
            url += params + "&";
        }
        url += "popupForm=" + this.data.name;
        this.iFrame.src = url;
        contentContainer.style.display = "none";
        contentContainer.appendChild(this.iFrame);
        this.iFrame.onload = () => {
            if (waitIcon) {
                this.modalContainer.removeChild(waitIcon);
                contentContainer.style.display = "block";
                waitIcon = null;
            }

            let entityType = document.querySelector("[entity-type]")?.getAttribute('entity-type');
            console.log("iframe.onLoad");
            console.log(entityType);
            if (entityType) {
                let entityLockable: boolean = (app.lockManager as LockManager).getLockableInfo(entityType);

                // check if the list is of lockable entities.. if yes:
                if (entityLockable == true) {
                    // Tell the list that it is for lockable objects.
                    let tableElement = document.querySelector("[entity-type]")
                    if (tableElement) {
                        tableElement.setAttribute("entity-lockable", "true");
                    }

                    // lock the opened object

                    let parsedObject = JSON.parse((this.iFrame.contentDocument.getElementById("jsonModel") as HTMLInputElement).value);
                    console.log(`Entity type: ${entityType} ID: ${parsedObject.id} --- Lockable? ${entityLockable}`);
                    (app.lockManager as LockManager).requestLock(parsedObject.id, entityType, this.iFrame.contentWindow);
                }
            }
        };
    }

    /** 
     *  Get the event which is fired when the form is submitted
     */
    get onBeforeSubmit() {
        return this._onBeforeSubmit.asEvent();
    }
    private _onBeforeSubmit = new EventDispatcher<Popup, PopupEventArgs>();

    /** 
     *  Get the event which is fired after submit
     */
    get onSubmitResult() {
        return this._onSubmitResult.asEvent();
    }
    private _onSubmitResult = new EventDispatcher<Popup, IPopupResult>();

    /** 
     *  Get the event which is fired when the popup is canceled
     */
    get onCancel() {
        return this._onCancel.asEvent();
    }
    private _onCancel = new EventDispatcher<Popup, any>();

    /** 
     *  Get the event which is fired when the popup is closed
     */
    get onClosed() {
        return this._onClosed.asEvent();
    }
    private _onClosed = new EventDispatcher<Popup, PopupEventArgs>();

    public initIFrame() {
        this.form = <HTMLFormElement>this.iFrame.contentDocument.getElementById(this.data.formId);
        if (this.form) {
            $(this.form).on('submit', () => {
                $.ajax({
                    url: this.form.action,
                    type: this.form.method,
                    data: $(this.form).serialize(),
                    success: (result: IPopupResult) => {
                        this.processModalFormResult(this.form, result);
                    },
                    error: (err) => {
                        app.addError(err.responseText);
                        console.log(err);
                    }
                });
                return false;
            });
        }
        else {
            app.addError("PopupForm.Popup.initIFrame: invalid form id '" + this.data.formId + "'");
        }
    }

    processModalFormResult(form: HTMLFormElement, result: IPopupResult) {
        this._onSubmitResult.dispatch(this, result);
        if (result.result == PopupResults.Error) {
            // update validation messages
            if (result.messages) {
                let validationElements = this.iFrame.contentDocument.querySelectorAll(".validation-summary-valid, .validation-summary-errors");
                for (let i = 0; i < validationElements.length; i++) {
                    let validationElement = validationElements[i];
                    validationElement.innerHTML = "";
                    let ul = this.iFrame.contentDocument.createElement("ul");
                    for (let message of result.messages) {
                        let li = this.iFrame.contentDocument.createElement("li");
                        li.innerText = message;
                        ul.appendChild(li);
                    }
                    validationElement.appendChild(ul);
                }

                let removeClass;
                let addClass;
                if (result.messages && result.messages.length) {
                    removeClass = "validation-summary-valid";
                    addClass = "validation-summary-errors";
                }
                else {
                    addClass = "validation-summary-valid";
                    removeClass = "validation-summary-errors";
                }
                for (let i = 0; i < validationElements.length; i++) {
                    let validationElement = validationElements[i];
                    validationElement.classList.remove(removeClass);
                    if (!validationElement.classList.contains(addClass))
                        validationElement.classList.add(addClass);
                }
            }
        }
        else if (result.result == PopupResults.Success) {
            this.close("save");
        }
        else if (result.result == PopupResults.DeleteSuccess) {
            this.close("delete");
        }
    }

    public save() {
        if (this.form) {
            this._onBeforeSubmit.dispatch(this, "save");
            $(this.form).submit();
        }
    }

    public cancel() {
        this._onCancel.dispatch(this, null);
        this.close("cancel");
    }

    public delete = () => {
        let postFn = () => {
            this._onBeforeSubmit.dispatch(this, "delete");
            if (this.form) {
                $.ajax({
                    cache: false,
                    url: app.resolveUrl(this.data.deleteUrl),
                    type: this.form.method,
                    data: $(this.form).serialize(),
                    success: (result: IPopupResult) => {
                        this.processModalFormResult(this.form, result);
                    },
                    error: (err) => {
                        console.log(err);
                        app.addError("ModalFromControllerBase.onDeleteClick - the server returned an error");
                    }
                });
            }
            else {
                app.addError("PopupForm.Popup.delete: invalid form id '" + this.data.formId + "'");
            }
        }

        if (this.data.deleteQuestion && this.data.deleteQuestion.length > 0) {
            new FixedDialog()
                .showYesNo(this.data.deleteQuestion)
                .done((res) => {
                    if (res == DialogResult.Yes) {
                        if (this.data.deletePromiseFnName) {
                            (<JQueryPromise<any>>window.getPropertyByPath(this.data.deletePromiseFnName)()).done(() => {
                                postFn();
                            });
                        }
                        else {
                            postFn();
                        }
                    }
                });
        }
        else {
            if (this.data.deletePromiseFnName) {
                (<JQueryPromise<any>>window[this.data.deletePromiseFnName]()).done(() => {
                    postFn();
                });
            }
            else {
                postFn();
            }
        }
    }

    close(args: PopupEventArgs) {
        if (this.modalContainer) {
            this.modalContainer.parentElement.removeChild(this.modalContainer);
            let parentPopups: Array<Popup> = window.parent["popups"];
            parentPopups.pop();
            this._onClosed.dispatch(this, args)
        }
    }
}
